

import React from 'react'
import { render } from 'react-dom'

import { Router } from '@reach/router'

import Route from '../../../../src/spa/pages/[[...route]].jsx'
import OnRouteChange from '../../../../src/spa/utility/hooks/routing.js'

import '../../css/index.spa.css'

render(
  <>
    <Router>
      <Route path='*' />
    </Router>
    <OnRouteChange />
  </>,
  document.getElementById('root')
)
